import React from 'react';
import { Attribute, Breaker } from 'types/Breaker';
import ActiveFilters from './ActiveFilters';
import BreakerCard from './BreakerCard';

type CollectionProps = {
  count: number;
  collectionName: 'breakers' | 'eggs' | 'gribbles';
  activeFilters: Attribute[];
  removeFilter: (attribute: Attribute) => void;
  clearFilters: () => void;
  items: Breaker[];
  loadMore: (() => void) | null;
  setId: (id: number) => void;
};

export const Collection = ({
  count,
  activeFilters,
  removeFilter,
  clearFilters,
  items,
  setId,
  loadMore,
  collectionName,
}: CollectionProps) => (
  <div className="col">
    <div className="row d-flex g-2">
      <div className="breaker-count">{`${Intl.NumberFormat('en-US').format(
        count,
      )} ${collectionName}`}</div>
      <ActiveFilters
        activeFilters={activeFilters}
        removeFilter={removeFilter}
        clearFilters={clearFilters}
      />

      {items.map((breaker, i) => {
        return (
          <div className="col-6 col-md-3" key={`${breaker.name}-${i}`}>
            <BreakerCard breaker={breaker} setSelectedBreaker={setId} />
          </div>
        );
      })}

      {loadMore && (
        <button className="btn" onClick={loadMore}>
          LOAD MORE
        </button>
      )}
    </div>
  </div>
);
